<template>
  <div class="flex flex-col gap-y-2">
    <div>
      <ol class="list-decimal ltr:font-sans text-sm flex flex-col gap-y-2 ps-8 pt-1">
        <li>{{ $t('canNotScanBarcodeMsg2') }}</li>
        <li>{{ $t('canNotScanBarcodeMsg3') }}</li>
        <li>
          <div class="flex flex-col gap-y-3 items-start">
            {{ $t('canNotScanBarcodeMsg4') }}
            <div
              class="max-w-64 w-full flex-shrink border border-brand-gray-600 bg-brand-gray-300 px-2 py-1.5 font-mono text-center"
            >
              {{ otpKey || 'hello' }}
            </div>
          </div>
        </li>
        <li>{{ $t('canNotScanBarcodeMsg5') }}</li>
        <li>{{ $t('canNotScanBarcodeMsg6') }}</li>
      </ol>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const otpKey = computed(() => sessionStorage.getItem('otpKey') || 'no otp key available')
</script>

<style lang="scss" scoped></style>
